import { IAgentSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { isFromBuilder, isHomeowner, isLeadFactory, isOfficialSeller } from './agent';
import { getAgentBrand } from './getAgentBrand';

export function getExtendedAgentBrand(agent: IAgentSchema | null, offer: IOfferSchema): string | undefined {
  if (isLeadFactory(offer)) {
    return 'Консультант';
  }

  if (isHomeowner(offer)) {
    return 'Собственник';
  }

  if (isFromBuilder(offer)) {
    return 'Застройщик';
  }

  if (isOfficialSeller(offer)) {
    return 'Представитель застройщика';
  }

  return getAgentBrand(agent, offer);
}
